import { useNavigate, useParams } from 'react-router-dom';
import CardLayout from '../../../components/Layout/CardLayout';
import request from '../../../request/request';
import useFetch from '../../../hooks/useFetch';
import LoaderLayout from '../../../components/Loader/LoaderLayout';
import { formDataConverter } from '../../../utils/necessaryFunctions';
import ProductFormContainer from '../../../components/Forms/Websites/Product/ProductFormContainer';

const UpdateProduct = () => {
    const { id } = useParams();
    console.log("update id", id)
    const navigate = useNavigate();

    const { result, isLoading } = useFetch(() => request.getOne('product', id));
    console.log(result);

    const UpdateAboutUsHandler = (formValue) =>
        request.updateOne('product', id, formValue, () => {
            navigate('/dashboard/website/product'); 
        });
    return (
        <LoaderLayout isPending={isLoading}>
            <CardLayout title='Update Product'>
                <ProductFormContainer apiHandler={UpdateAboutUsHandler} editData={result} />
            </CardLayout>
        </LoaderLayout>
    );
};

export default UpdateProduct;
